import React, { useCallback, useEffect, useState } from "react";
import { Paper, CircularProgress, TextField, Dialog } from "@material-ui/core";
import { Formik } from "formik";
import { useParams } from "react-router-dom";
import { QRCodeCanvas } from 'qrcode.react';
import { CropFreeTwoTone } from "@material-ui/icons";
import Modal from "@/components/Modal";
import {
  getCompanyCertInfoAPI,
  getQRCodeInfo,
  updateCompanyCertInfoAPI
} from "@/apis/apiCollection";
import useStyles from "@/styles/profileCardStyle";
import { useTranslation } from "@/langs/useTranslation";
import SubmitButton from "../commons/SubmitButton";

const CertificationInfoCard = ({ create }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { company_id } = useParams();
  const [isLoading, setIsLoading] = useState(company_id === "new" ? false : true);
  const [updating, setUpdating] = useState(false);
  const [certInfo, setCertInfo] = useState({ app_id: null, app_secret: null, isShowQR: false });
  const [qrcodeOpen, setQRCodeOpen] = useState(false)
  const [qrcodeValue, setQRCodeValue] = useState('')

  const getCompanyCertInfo = useCallback(async () => {
    try {
      setIsLoading(true);
      const { info } = await getCompanyCertInfoAPI(company_id);
      const { app_id, app_secret, isShowQR } = info || {};
      setCertInfo({ app_id, app_secret, isShowQR });
    } finally {
      setIsLoading(false);
    }
  }, [company_id]);

  // const updateCompanyCertInfo = async () => {
  //   try {
  //     setUpdating(true);
  //     await updateCompanyCertInfoAPI(company_id);
  //   } finally {
  //     setUpdating(false);
  //   }
  // };

  useEffect(() => {
    if (!create) getCompanyCertInfo();
  }, [getCompanyCertInfo]);

  console.log("??")
  useEffect(() => {
    if (certInfo.isShowQR) {
      getQRCodeInfo({ companyId: company_id }).then(res => {
        setQRCodeValue(JSON.stringify(res))
      })
    }
  }, [certInfo.isShowQR, company_id])

  return (
    <Paper elevation={0} className={`height-100 ${classes.companyProfileForm}`}>
      {isLoading ? (
        <div className={classes.loadingWrap}>
          <CircularProgress />
        </div>
      ) : (
        <div style={{ display: 'flex' }}>
          <Formik initialValues={certInfo}>
            {({ values }) => (
              <form className={classes.mainContent}>
                <TextField
                  name="app_id"
                  value={values.app_id}
                  className={`${classes.input} ${classes.inputLong}`}
                  label="App ID"
                  disabled
                  style={{ width: 170, marginRight: 24 }}
                />
                <TextField
                  name="app_secret"
                  value={values.app_secret}
                  className={`${classes.input} ${classes.inputLong}`}
                  label="App Secret"
                  disabled
                  style={{ width: 435 }}
                />
                {/* <SubmitButton
                color="primary"
                type="button"
                loading={updating}
                onClick={updateCompanyCertInfo}
              >
                {t({ defaultMessage: "更新" })}
              </SubmitButton> */}
              </form>
            )}
          </Formik>
          {certInfo.isShowQR && (
            <CropFreeTwoTone style={{ marginLeft: 16, marginTop: 16, cursor: 'pointer' }} onClick={() => setQRCodeOpen(true)} />
          )}
          <Modal
            title=" "
            open={qrcodeOpen}
            onClose={() => setQRCodeOpen(false)}
            footer={<></>}
          >
            <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
              {qrcodeValue && (
                <QRCodeCanvas
                  value={qrcodeValue}
                  size={300}
                  level="M"
                  includeMargin={true}
                  fgColor="#000000"
                  bgColor="#FFFFFF"
                />
              )}
            </div>
          </Modal>
        </div>
      )}
    </Paper>
  );
};

export default CertificationInfoCard;
